module.exports = __webpack_public_path__ + "img/DE01287.496c8ac5.png";